//tslint:disable-next-line
import { v4 as uuidv4 } from 'uuid';
import bcrypt from 'bcryptjs';

export const generateSecret = () => {
	return uuidv4();
};

export const hashSecret = async (secret: string) => {
	return bcrypt.hash(secret, 10);
};

export const compareSecret = async (secret: string, hash: string) => {
	return bcrypt.compare(secret, hash);
};
